export const heroSlides = [
  {
    movieId: 1,
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20science%20fiction%20backdrop%2C%20lone%20astronaut%20silhouette%20gazing%20at%20a%20vast%20glowing%20orange%20planet%20and%20nebula%2C%20deep%20blue%20space%20with%20dramatic%20rim%20light%2C%20wide%20film%20composition%2C%20high%20detail%20atmospheric%20cinematography&width=1600&height=900&seq=hero-backdrop-01&orientation=landscape",
  },
  {
    movieId: 10,
    backdrop:
      "https://readdy.ai/api/search-image?query=Futuristic%20cyberpunk%20city%20backdrop%20at%20night%2C%20towering%20holographic%20billboards%20and%20neon%20lights%20in%20deep%20blue%20and%20orange%2C%20rain%20slicked%20streets%20reflecting%20glow%2C%20wide%20cinematic%20film%20composition%2C%20high%20detail%20moody%20atmosphere&width=1600&height=900&seq=hero-backdrop-02&orientation=landscape",
  },
  {
    movieId: 5,
    backdrop:
      "https://readdy.ai/api/search-image?query=Deep%20ocean%20cinematic%20backdrop%2C%20submersible%20spotlight%20cutting%20through%20dark%20water%20revealing%20a%20giant%20looming%20shadow%2C%20deep%20blue%20and%20cyan%20tones%20with%20warm%20amber%20light%2C%20wide%20thrilling%20film%20composition%2C%20high%20detail&width=1600&height=900&seq=hero-backdrop-03&orientation=landscape",
  },
  {
    movieId: 2,
    backdrop:
      "https://readdy.ai/api/search-image?query=Rainy%20neon%20city%20alley%20at%20night%20cinematic%20backdrop%2C%20wet%20asphalt%20reflecting%20amber%20streetlights%20and%20deep%20blue%20shadows%2C%20empty%20moody%20urban%20scene%2C%20wide%20film%20composition%2C%20high%20detail%20atmospheric%20cinematography&width=1600&height=900&seq=hero-backdrop-04&orientation=landscape",
  },
  {
    movieId: 15,
    backdrop:
      "https://readdy.ai/api/search-image?query=Space%20rescue%20cinematic%20backdrop%2C%20damaged%20orbital%20space%20station%20silhouette%20against%20glowing%20earth%20limb%2C%20deep%20blue%20void%20and%20warm%20orange%20sunlight%2C%20wide%20tense%20film%20composition%2C%20high%20detail%20cinematography&width=1600&height=900&seq=hero-backdrop-05&orientation=landscape",
  },
];